module.exports = __webpack_public_path__ + "img/bottle-left.24557220.png";